module.exports = __webpack_public_path__ + "img/gongshui-1.7fd5d33d.png";